<div class="ra-search-bar-field flex-grow-1 min-w-0">
  <mat-form-field
    class="ra-search-bar-field__form"
    [ngClass]="formFieldClass"
    [class.ra-search-bar-field__form--disabled]="isDisabled"
  >
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      type="text"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
    />
    <mat-icon matSuffix>{{ suffixIcon }}</mat-icon>
  </mat-form-field>
</div>
